import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const teamGens1 = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Александр Букуров',
            crewItemSubtitle: 'старший менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Александр Шпигальский',
            crewItemSubtitle: 'менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'руководитель группы разработки',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'ведущий разработчик',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Алина Климец',
            crewItemSubtitle: 'контент-менеджер',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший дизайнер',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Анна Сластен',
            crewItemSubtitle: 'дизайнер',
        },
    ],
};

const teamGens12 = {
    crewTitle: 'GenerationS',
    crewSubtitle: 'Выражаем благодарность команде:',
    crewList: [
        {
            crewItemImg: null,
            crewItemTitle: 'Екатерина Петрова',
            crewItemSubtitle: 'Директор корпоративного акселератора GenerationS',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Татьяна Мажутис',
            crewItemSubtitle: 'Менеджер по развитию экосистемы',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Анатолий Бородин',
            crewItemSubtitle: 'Менеджер акселерационных программ, развитие методологии',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Кирилл Лазарчук',
            crewItemSubtitle: 'Менеджер акселерационных программ, экспертиза проектов',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Юрий Федоров',
            crewItemSubtitle: 'Руководитель службы цифровых коммуникаций',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Юрий Руренко',
            crewItemSubtitle: 'менеджер цифровых коммуникаций',
        },
    ],
};

const Team = () => {
    return (
        <FullWrapper caseName="gens-team">
            <CommonTitle>Команда</CommonTitle>
            <CommonUsualText className="gens-team__text">
                Каждому клиенту мы&nbsp;предоставляем отдельную проектную команду.
                Над&nbsp;созданием платформы GenerationS работали 9&nbsp;человек с&nbsp;нашей
                стороны и&nbsp;6&nbsp;человек со&nbsp;стороны заказчика:
            </CommonUsualText>
            <CrewContainer container={teamGens1} />
            <CrewContainer container={teamGens12} />
        </FullWrapper>
    );
};

export default Team;
